import { render } from "./explore-nbr.vue?vue&type=template&id=290fd2aa"
import script from "./explore-nbr.vue?vue&type=script&lang=js"
export * from "./explore-nbr.vue?vue&type=script&lang=js"

import "./explore-nbr.vue?vue&type=style&index=0&id=290fd2aa&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/search-result/explore-nbr.vue'],['render',render],['__file',"explore-nbr.vue"]])

export default __exports__